/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S6_Li1Inputs */

const tr_onbilgi_s6_li1 = /** @type {(inputs: Onbilgi_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Süre bitiminden 7 (yedi) gün ve 1 (bir) gün önce kayıtlı e-posta adresine, bitiş tarihini ve yenileme bağlantısını içeren bir hatırlatma gönderilir.`)
};

const en_onbilgi_s6_li1 = /** @type {(inputs: Onbilgi_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 (seven) days and 1 (one) day before the end of the term a reminder with the end date and the renewal link is sent to the registered email address.`)
};

const de_onbilgi_s6_li1 = /** @type {(inputs: Onbilgi_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 (sieben) Tage und 1 (einen) Tag vor dem Ende geht an die hinterlegte E-Mail-Adresse eine Erinnerung mit Enddatum und Verlängerungs-Link.`)
};

const ru_onbilgi_s6_li1 = /** @type {(inputs: Onbilgi_S6_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За 7 (семь) дней и за 1 (один) день до окончания срока на зарегистрированный адрес электронной почты направляется напоминание с датой окончания и ссылкой на продление.`)
};

/**
* | output |
* | --- |
* | "7 (seven) days and 1 (one) day before the end of the term a reminder with the end date and the renewal link is sent to the registered email address." |
*
* @param {Onbilgi_S6_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s6_li1 = /** @type {((inputs?: Onbilgi_S6_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S6_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s6_li1(inputs)
	if (locale === "de") return de_onbilgi_s6_li1(inputs)
	if (locale === "ru") return ru_onbilgi_s6_li1(inputs)
	return tr_onbilgi_s6_li1(inputs)
});